import { z } from 'zod';

export const phoneSchema = z
  .string()
  .min(10, 'Nomor telepon minimal 10 digit')
  .max(15, 'Nomor telepon maksimal 15 digit')
  .regex(/^(\+62|62|0)[0-9]{9,12}$/, 'Format nomor telepon tidak valid');

export const indonesiaPhoneSchema = z
  .string()
  .transform((val) => {
    if (val.startsWith('+62')) return val;
    if (val.startsWith('62')) return '+' + val;
    if (val.startsWith('0')) return '+62' + val.slice(1);
    return '+62' + val;
  })
  .pipe(phoneSchema);

export function validatePhoneNumber(phone: string): { valid: boolean; error?: string } {
  const result = phoneSchema.safeParse(phone);
  if (result.success) {
    return { valid: true };
  }
  return { valid: false, error: result.error.errors[0]?.message };
}

export function normalizePhoneNumber(phone: string): string {
  const trimmed = phone.trim();
  if (trimmed.startsWith('+62')) return trimmed;
  if (trimmed.startsWith('62')) return '+' + trimmed;
  if (trimmed.startsWith('0')) return '+62' + trimmed.slice(1);
  return '+62' + trimmed;
}

export function formatPhoneNumber(phone: string): string {
  const normalized = normalizePhoneNumber(phone);
  return normalized.replace(/(\+62)(\d{2,3})(\d{3,4})(\d{3,4})/, '$1 $2 $3 $4');
}
